import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const HERO_BACKGROUND =
  "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=2000&q=80";

function scrollTo(id: string) {
  const el = document.getElementById(id);
  el?.scrollIntoView({ behavior: "smooth", block: "start" });
}

export function HeroSection() {
  const { t } = useTranslation("landing");

  return (
    <Box
      id="top"
      component="section"
      sx={{
        position: "relative",
        minHeight: { xs: "70vh", md: "86vh" },
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        color: "#FFFFFF",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundImage: `linear-gradient(180deg, rgba(22,20,18,0.35) 0%, rgba(22,20,18,0.78) 100%), url(${HERO_BACKGROUND})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          zIndex: -1,
        },
      }}
    >
      <Container maxWidth="lg">
        <Stack
          spacing={3}
          sx={{
            maxWidth: 740,
            py: { xs: 8, md: 12 },
            px: { xs: 3, sm: 4, md: 5 },
            borderRadius: 4,
            border: "1px solid rgba(255,255,255,0.2)",
            background: "linear-gradient(180deg, rgba(20,18,16,0.42) 0%, rgba(20,18,16,0.58) 100%)",
            backdropFilter: "blur(4px)",
          }}
        >
          <Typography
            variant="overline"
            sx={{ letterSpacing: 4, color: "rgba(255,255,255,0.85)", fontWeight: 600 }}
          >
            {t("hero.eyebrow")}
          </Typography>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.5rem", sm: "3.5rem", md: "4.2rem" },
              lineHeight: 1.1,
              color: "#FFFFFF",
            }}
          >
            {t("hero.title")}
          </Typography>
          <Typography
            variant="h6"
            component="p"
            sx={{ fontWeight: 400, color: "rgba(255,255,255,0.9)", maxWidth: 620 }}
          >
            {t("hero.subtitle")}
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mt: 2.5 }}>
            <Button
              size="large"
              variant="contained"
              color="primary"
              startIcon={<EmailOutlinedIcon />}
              onClick={() => scrollTo("contact")}
            >
              {t("hero.primaryCta")}
            </Button>
            <Button
              size="large"
              variant="outlined"
              color="inherit"
              startIcon={<CollectionsOutlinedIcon />}
              onClick={() => scrollTo("gallery")}
              sx={{ borderColor: "rgba(255,255,255,0.6)", color: "#FFFFFF" }}
            >
              {t("hero.secondaryCta")}
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
